import { render, staticRenderFns } from "./fenhong.vue?vue&type=template&id=3b27d867&scoped=true"
import script from "./fenhong.vue?vue&type=script&lang=js"
export * from "./fenhong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b27d867",
  null
  
)

export default component.exports